import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/errors`;

export const getAll = async () => {
 const {data} = await axios.get(baseUrl, config) 
 return data
}

export const create = async ({error}) => {
 const {data} = await axios.post(baseUrl, error, config) 
 return data
}

export const getAllByUser = async () => {
 const {data} = await axios.get(`${baseUrl}/findAllByUser`, config) 
 return data
}

export const getOne = async ({id}) => {
 const {data} = await axios.get(`${baseUrl}/findOne/${id}`, config);
 return data;
}